import { colors } from '@nw/shared/config';

interface FieldLabelProps {
  isValid: boolean;
  inputFieldStyles?: {
    defaultLabelColor: string;
    errorLabelColor: string;
  };
}

interface FieldBorderProps {
  isValid: boolean;
  inputFieldStyles?: {
    defaultBorderColor: string;
    errorBorderColor: string;
  };
}

export const getDatePickerFieldLabelColor = (props: FieldLabelProps) =>
  props.isValid
    ? props.inputFieldStyles
      ? props.inputFieldStyles.defaultLabelColor
      : colors.darkGray
    : props.inputFieldStyles
      ? props.inputFieldStyles.errorLabelColor
      : colors.lipstick;

export const getInputFieldLabelColor = (props: FieldLabelProps) =>
  props.isValid
    ? props.inputFieldStyles
      ? props.inputFieldStyles.defaultLabelColor
      : colors.darkGray
    : props.inputFieldStyles
      ? props.inputFieldStyles.errorLabelColor
      : colors.lipstick;

export const getInputFieldBorderColor = (props: FieldBorderProps) =>
  props.isValid
    ? props.inputFieldStyles
      ? `1px solid ${props.inputFieldStyles.defaultBorderColor}`
      : `1px solid ${colors.darkGray}`
    : props.inputFieldStyles
      ? `2px solid ${props.inputFieldStyles.errorBorderColor}`
      : `2px solid ${colors.lipstick}`;
